var matchHeight = function () {
  function init() {
    eventListeners();
    matchHeight();
  }

  function eventListeners() {
    jQuery(window).on('resize', function () {
      matchHeight();
    });
  }

  function matchHeight() {
    var groupName = jQuery('.timeline__text');
    var groupHeights = [];
    groupName.css('min-height', 'auto');
    groupName.each(function () {
      groupHeights.push(jQuery(this).outerHeight());
    });
    var maxHeight = Math.max.apply(null, groupHeights);
    groupName.css('min-height', maxHeight);
  }

  ;
  return {
    init: init
  };
}();

jQuery(document).ready(function () {
  matchHeight.init();
});